import type { SelectedId } from "@/components/molecules/MultiSelectDropdown/MultiSelectDropdownView/type";
import { useCallback } from "react";

export function useMultiSelect(selectedIds: SelectedId[], onChange: (ids: SelectedId[]) => void) {
  const isChecked = useCallback((id: SelectedId) => selectedIds.some((x) => String(x) === String(id)), [selectedIds]);
  const toggle = useCallback(
    (id: SelectedId) => {
      const s = new Set(selectedIds.map(String));
      const k = String(id);
      s.has(k) ? s.delete(k) : s.add(k);
      onChange(Array.from(s)); // keep as Id[] if you stored Id in the set
    },
    [selectedIds, onChange],
  );
  return { isChecked, toggle };
}
